export default [
    {path: 'add'},      
    {path: 'upload'},//not used
    {path: 'edit/:item_id'} ,
    {path: 'details/:item_id'} ,
    {path: 'delete/:item_id'} ,//not used
]